"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverDateToJSDate = serverDateToJSDate;
exports.format_order_statuses = format_order_statuses;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// format (y-m-d) and (y-m-d h:m:s)
function serverDateToJSDate(date) {
  return (0, _dayjs.default)(date).toDate(); // let [datePart, timePart] = date.split(" ");
  // let [y, m, d] = datePart.split("-");
  // let year = Number(y);
  // let month = Number(m);
  // let day = Number(d);
  // let outputDate = new Date();
  // outputDate.setUTCFullYear(year);
  // outputDate.setUTCMonth(month - 1);
  // outputDate.setUTCDate(day);
  // console.log({ date, month, outputDate });
  // if (timePart) {
  //   let [h, min, s] = timePart.split(":");
  //   let hour = Number(h);
  //   let minutes = Number(min);
  //   let seconds = Number(s);
  //   outputDate.setHours(hour);
  //   outputDate.setMinutes(minutes);
  //   outputDate.setSeconds(seconds);
  // }
  // return outputDate;
}

function format_order_statuses(status) {
  switch (status) {
    case "submitted_by_customer":
    case "submitted_by_crm":
      return {
        text: "سبد خرید",
        color: "common.black"
      };

    case "ready_to_collect":
      return {
        text: "ثبت شده",
        color: "green.main"
      };

    case "collected":
      return {
        text: "تحویل گرفته شده",
        color: "green.dark"
      };

    case "collection_not_present":
      return {
        text: "عدم حضور",
        color: "red.main"
      };

    case "unwrapped":
      return {
        text: "آماده شستشو",
        color: "primary.dark"
      };

    case "in_progress":
      return {
        text: "در حال شستشو",
        color: "primary.dark"
      };

    case "work_done":
      return {
        text: "تعیین زمان تحویل",
        color: "secondary.main"
      };

    case "ready_to_deliver":
      return {
        text: "آماده تحویل‌",
        color: "green.main"
      };

    case "delivery_not_present":
      return {
        text: "عدم حضور",
        color: "red.main"
      };

    case "delivered":
      return {
        text: "تحویل داده شد",
        color: "green.main"
      };

    case "canceled_by_customer":
    case "canceled_by_system":
      return {
        text: "کنسل شده",
        color: "red.main"
      };

    case "delivery_canceled":
      return {
        text: "تحویل لغو شده",
        color: "red.main"
      };

    case "collection_canceled":
      return {
        text: "جمع‌آوری لغو شده",
        color: "red.main"
      };

    default:
      return {
        text: "نامشخص",
        color: "common.black"
      };
  }
}